/* eslint-disable no-nested-ternary */

"use client"

import React from "react"

import PageGrid from "@/ui/components/PageGrid"

import CustomersCarousel from "./CustomersCarousel"

interface customerCarouselProps {
  data: any
}

const CustomersCarouselProvider: React.FC<customerCarouselProps> = ({
  data,
}) => (
  <div>
    <PageGrid className="pt-4 md:pt-12 xl:pt-16" isGrid={false}>
      <div className="w-full mb-6 md:mb-10 lg:mb-20">
        <CustomersCarousel data={data} />
      </div>
    </PageGrid>
  </div>
)

export default CustomersCarouselProvider
